module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./componentBase.schema.json"));
	}, "validators");
}


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/components/_base/componentBase.schema.json
// module id = 125
// module chunks = 1